import type { ReactElement } from 'react';
import { View } from 'react-native';

/**
 * Web counterpart to `MaybeGrayscale`. The native color-matrix filter used on
 * iOS/Android is a native-only module (it imports RN internals Metro refuses
 * to bundle for web), so web keeps the plain CSS `filter`, which is exact here.
 */
export default function MaybeGrayscale({
  enabled,
  children,
}: {
  enabled: boolean;
  children: ReactElement;
}) {
  return enabled ? (
    <View style={{ filter: 'grayscale(1)' }}>{children}</View>
  ) : (
    children
  );
}
